import { useState, useRef } from 'react';
import { ANIMATION_TIMINGS } from '../constants';

/**
 * Custom hook for managing toast notifications
 */
export const useToast = () => {
  const [toast, setToast] = useState('');
  const [toastHex, setToastHex] = useState('');
  const [toastColors, setToastColors] = useState([]);
  const [toastExiting, setToastExiting] = useState(false);
  const timerRef = useRef(null);

  const show = (message, hexValue = '', hexColors = []) => {
    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    setToastExiting(false);
    setToast(message);
    setToastHex(hexValue);
    setToastColors(hexColors);

    // Set timer to hide toast
    timerRef.current = setTimeout(() => {
      setToastExiting(true);
      setTimeout(() => {
        setToast('');
        setToastHex('');
        setToastColors([]);
        setToastExiting(false);
      }, ANIMATION_TIMINGS.TOAST_EXIT);
    }, ANIMATION_TIMINGS.TOAST_DURATION);
  };

  return {
    toast,
    toastHex,
    toastColors,
    toastExiting,
    show,
  };
};

